import { CheckCircle2, Clock, HelpCircle } from 'lucide-react'

import type { FreshnessVm } from '../model/types'

/**
 * Свежесть данных 1С: слово, значок и рамка. Устаревшее не выдаётся за
 * актуальное, а «не сообщено» — не за «актуально».
 */
export function FreshnessBadge({ freshness }: { freshness: FreshnessVm | null }) {
  if (freshness === null) return null
  const icon =
    freshness.kind === 'fresh' ? (
      <CheckCircle2 size={14} aria-hidden="true" />
    ) : freshness.kind === 'stale' ? (
      <Clock size={14} aria-hidden="true" />
    ) : (
      <HelpCircle size={14} aria-hidden="true" />
    )
  return (
    <span className="onec-freshness" data-kind={freshness.kind} role="status" title={freshness.detail ?? undefined}>
      {icon}
      <span>{freshness.label}</span>
      {freshness.detail !== null && freshness.kind !== 'fresh' && <span className="onec-muted">— {freshness.detail}</span>}
      {freshness.detail !== null && freshness.kind === 'fresh' && <span className="onec-muted">{freshness.detail}</span>}
    </span>
  )
}
